module.exports = __webpack_public_path__ + "static/media/FAU_Green.68faaf98.png";